var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "billing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#d534fc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "billing-2",
    "data-name": "billing",
    d: "M16.5,15H6.9V13.4h9.6Zm0-3.2H6.9V10.2h9.6Zm0-3.2H6.9V7h9.6ZM4.5,19l1.2-1.2L6.9,19l1.2-1.2L9.3,19l1.2-1.2L11.7,19l1.2-1.2L14.1,19l1.2-1.2L16.5,19l1.2-1.2L18.9,19V3L17.7,4.2,16.5,3,15.3,4.2,14.1,3,12.9,4.2,11.7,3,10.5,4.2,9.3,3,8.1,4.2,6.9,3,5.7,4.2,4.5,3Z",
    transform: "translate(8.079 9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling1);
export default __webpack_public_path__ + "static/media/billing_1.536919275666cc44c0933d0fcb9d2bdc.svg";
export { ForwardRef as ReactComponent };